import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home/home'
import Layout from '@/views/layout/layout'
import Register from '@/views/login/register'
import Login from '@/views/login/login'
import ModifyPassword from '@/views/login/modifyPassword'
import Publish from '@/views/publish/publish'
import UpdatePublish from '@/views/publish/updatePublish'
import PublishQuery from '@/views/publish/publishQuery'
import Apply from '@/views/publish/apply'
import PubAdvert from '@/views/publish/pubAdvert'
import PublishSetting from '@/views/setting/publishSetting'
import QuitQuery from '@/views/publish/quitQuery.vue'
import TeamSetting from '@/views/team/teamSetting'
import TeamFullArrange from '@/views/teamFullScreen/fullArrange'
import TeamFullScoreRefresh from '@/views/teamFullScreen/fullScoreRefresh'
import TeamFullGroupRankQuery from '@/views/teamFullScreen/fullGroupRankQuery'

import TeamSign from '@/views/team/TeamSign'
import AuthInfo from '@/views/auth/authInfo'
import AdminAudit from '@/views/admin/adminAudit'
import UserInfo from '@/views/userInfo/userInfo'
import HostQuery from '@/views/admin/hostQuery'
import UnderTake from '@/views/admin/underTake'
import Sponsor from '@/views/admin/Sponsor'
import Organizer from '@/views/admin/organizer'
import RefereeQuery from '@/views/admin/refereeQuery'
import Association from '@/views/association/association'
import Sign from '@/views/signIn/signIn'
// import ScoreSearch from '@/views/signIn/scoreSearch'
import News from '@/views/news/news'
import NewsQuery from '@/views/news/newsQuery'
import NewsDetail from '@/views/news/newsDetail'
import Advert from '@/views/news/advert'
import AdvertQuery from '@/views/news/advertQuery'
import PlayerScoreQuery from '@/views/playerScore/PlayerScoreQuery'
import PlayerScore from '@/views/playerScore/playerScore'
import TotalScore from '@/views/playerScore/totalScore'
import PaymentQuery from '@/views/playerScore/paymentQuery'
import Train from '@/views/training/train'
import TrainQuery from '@/views/training/trainQuery'
import TrainDetail from '@/views/training/TrainDetail'
import TrainApplyQuery from '@/views/training/trainApplyQuery'
import TrainPayment from '@/views/training/trainPayment'
import PublishPreview from '@/views/publish/publishPreview'
import UpdatePreview from '@/views/publish/UpdatePreview'
import NewPublishQuery from '@/views/publish/newPublish'
import GradeQuery  from '@/views/playerScore/gradeQuery'
import NewsPage from '@/views/news/newsPage'
import IntegralLog from '@/views/admin/integralLog'
import GroupRankQuery from '@/views/playerScore/groupRankQuery'
import TeamGroupRankQuery from '@/views/playerScore/teamGroupRankQuery'
import TraineeSetting from '@/views/traineeManage/traineeSetting'
import TraineeQuery from '@/views/traineeManage/traineeQuery'
import Product from '@/views/product/product'
import SpecDetail from '@/views/product/specDetail'
import OrderQuery from  '@/views/product/orderQuery'
import ProductAdvert from '@/views/product/productAdvert'
import AddressQuery from '@/views/admin/addressQuery'
import Cooperator from '@/views/admin/cooperator'
// 全屏的5个页面
import FullCountdown from '@/views/fullScreen/fullCountdown'
import FullArrange from '@/views/fullScreen/fullArrange'
import FullScoreQuery from '@/views/fullScreen/fullScoreQuery'
import FullTotalTank from '@/views/fullScreen/fullTotalTank'
import FullScoreRefresh from '@/views/fullScreen/fullScoreRefresh'
import FullGroupRankQuery from '@/views/fullScreen/FullGroupRankQuery'
Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            name: 'layout',
            component: Layout,
            redirect: '/index',
            children: [{
                    path: '/index',
                    name: 'home',
                    component: home,
                    meta: { requireAuth: false }
                },               
                {
                    path: '/publish',
                    name: 'publish',
                    component: Publish,
                    meta: { keepAlive:false, requireAuth: true, title: '赛事发布' }
                },    
                {
                    path: '/updatePublish',
                    name: 'updatePublish',
                    component: UpdatePublish,
                    meta: { requireAuth: true, title: '修改赛事' }
                },    
                {
                    path: '/newPublishQuery',
                    name: 'newPublishQuery',
                    component: NewPublishQuery,
                    meta: { requireAuth: true, title: '赛事列表' }
                },  
                {
                    path: '/updatePreview',
                    name: 'updatePreview',
                    component: UpdatePreview,
                    meta: { requireAuth: true, title: '编辑预览赛事' }
                },  
                {
                    path: '/pubSetting',
                    name: 'publishSetting',
                    component: PublishSetting,
                    meta: { requireAuth: true, title: '比赛设置' }
                },   
                {
                    path: '/teamSetting',
                    name: 'teamSetting',
                    component: TeamSetting,
                    meta: { requireAuth: true, title: '队式赛设置' }
                },              
                {
                    path: '/register',
                    name: 'register',
                    component: Register,
                    meta: { requireAuth: false, title: '注册', }
                },
                {
                    path: '/authInfo',
                    name: 'authInfo',
                    component: AuthInfo,
                    meta: { requireAuth: true, title: '信息认证', }
                },
                {
                    path: '/admin',
                    name: 'adminAudit',
                    component: AdminAudit,
                    meta: { requireAuth: true, title: '管理员审核', }
                },
                {
                    path: '/hostQuery',
                    name: 'hostQuery',
                    component: HostQuery,
                    meta: { requireAuth: true, title: '主办方查询', }
                },
               
                {
                    path: '/underTake',
                    name: 'underTake',
                    component: UnderTake,
                    meta: { requireAuth: true, title: '承办方查询', }
                },
                {
                    path: '/sponsor',
                    name: 'sponsor',
                    component: Sponsor,
                    meta: { requireAuth: true, title: '冠名方查询', }
                },
                {
                    path: '/organizer',
                    name: 'organizer',
                    component: Organizer,
                    meta: { requireAuth: true, title: '协办方查询', }
                },
                {
                    path: '/referee',
                    name: 'referee',
                    component: RefereeQuery,
                    meta: { requireAuth: true, title: '裁判查询', }
                },
                {
                    path: '/association',
                    name: 'association',
                    component: Association,
                    meta: { requireAuth: true, title: '协会管理', }
                },
                {
                    path: '/modifyPassword',
                    name: 'modifyPassword',
                    component: ModifyPassword,
                    meta: { requireAuth: true, title: '修改密码' }
                },
                {
                    path: '/userInfo',
                    name: 'userInfo',
                    component: UserInfo,
                    meta: { requireAuth: true, title: '个人信息' }
                },
                {
                    path: '/news',
                    name: 'news',
                    component: News,
                    meta: { requireAuth: true, title: '发布新闻' }
                },
                {
                    path: '/newsPage',
                    name: 'newsPage',
                    component: NewsPage,
                    meta: { requireAuth: true, title: '发布新闻' }
                },
                {
                    path: '/newsQuery',
                    name: 'newsQuery',
                    component: NewsQuery,
                    meta: { requireAuth: true, title: '新闻查询' }
                },              
                {
                    path: '/advert',
                    name: 'advert',
                    component: Advert,
                    meta: { requireAuth: true, title: '赛事广告' }
                },
                {
                    path: '/advertQuery',
                    name: 'advertQuery',
                    component: AdvertQuery,
                    meta: { requireAuth: true, title: '广告查询' }
                },
                {
                    path: '/playerScoreQuery',
                    name: 'playerScoreQuery',
                    component: PlayerScoreQuery,
                    meta: {requireAuth: false, title: '赛事查询'}
                },
                {
                    path: '/train',
                    name: 'train',
                    component: Train,
                    meta: {requireAuth: true, title: '发布培训'}
                },
                {
                    path: '/trainQuery',
                    name: 'trainQuery',
                    component: TrainQuery,
                    meta: {requireAuth: true, title: '培训查询'}
                },
                {
                    path: '/trainDetail',
                    name: 'trainDetail',
                    component: TrainDetail,
                    meta: {requireAuth: true, title: '培训详情'}
                },
                {
                    path: '/trainApplyQuery',
                    name: 'trainApplyQuery',
                    component: TrainApplyQuery,
                    meta: {requireAuth: true, title: '学员报名信息'}
                },
                {
                    path: '/trainPayment',
                    name: 'trainPayment',
                    component: TrainPayment,
                    meta: {requireAuth: true, title: '培训支付查询'}
                },
                {
                    path: '/paymentQuery',
                    name: 'paymentQuery',
                    component: PaymentQuery,
                    meta: {requireAuth: true, title: '支付查询'}
                },
                {
                    path: '/pubAdvert',
                    name: 'pubAdvert',
                    component: PubAdvert,
                    meta: {requireAuth: true, title: '赛事广告设置'}
                },
                {
                    path: '/integralLog',
                    name: 'integralLog',
                    component: IntegralLog,
                    meta: {requireAuth: true, title: '积分日志查询'}
                },
                {
                    path: '/groupRankQuery',
                    name: 'groupRankQuery',
                    component: GroupRankQuery,
                    meta: {requireAuth: false, title: '团体排名'}
                },
                 {
                    path: '/teamGroupRankQuery',
                    name: 'teamGroupRankQuery',
                    component: TeamGroupRankQuery,
                    meta: {requireAuth: false, title: '团体排名'}
                },
                {
                    path: '/traineeSetting',
                    name: 'traineeSetting',
                    component: TraineeSetting,
                    meta: {requireAuth: false, title: '证书设置'}
                },
                {
                    path: '/traineeQuery',
                    name: 'traineeQuery',
                    component: TraineeQuery,
                    meta: {requireAuth: false, title: '证书查询'}
                },
                {
                    path: '/product',
                    name: 'product',
                    component: Product,
                    meta: {requireAuth: false, title: '商品查询'}
                },
                {
                    path: '/specDetail',
                    name: 'specDetail',
                    component: SpecDetail,
                    meta: {requireAuth: true, title: '规格查询'}
                },
                {
                    path: '/orderQuery',
                    name: 'orderQuery',
                    component: OrderQuery,
                    meta: {requireAuth: false, title: '订单查询'}
                },
                {
                    path: '/productAdvert',
                    name: 'productAdvert',
                    component: ProductAdvert,
                    meta: {requireAuth: false, title: '商城广告'}
                },
                {
                    path: '/addressQuery',
                    name: 'addressQuery',
                    component: AddressQuery,
                    meta: {requireAuth: false, title: '地址查询'}
                },
                {
                    path: '/quitQuery',
                    name: 'quitQuery',
                    component: QuitQuery,
                    meta: {requireAuth: false, title: '退赛查询'}
                },
                {
                    path: '/cooperator',
                    name: 'cooperator',
                    component: Cooperator,
                    meta: {requireAuth: true, title: '合作单位'}
                }
            ],
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: { title: '登录' }
        },  
        {
            path: '/apply',
            name: 'apply',
            component: Apply,
            meta: { requireAuth: false, title: '赛事报名' }
        },   
        {
            path: '/publishQuery',
            name: 'publishQuery',
            component: PublishQuery,
            meta: { requireAuth: false, title: '赛事邀请' }
        },  
        {
            path: '/publishPreview',
            name: 'publishPreview',
            component: PublishPreview,
            meta: { requireAuth: false, title: '赛事预览' }
        },  
        {
            path: '/sign',
            name: 'signIn',
            component: Sign,
            meta: {requireAuth: false, title: '签到'}
        },
        {
            path: '/playerScore',
            name: 'playerScore',
            component: PlayerScore,
            meta: {requireAuth: false, title: '赛事成绩'}
        },
        {
            path: '/totalScore',
            name: 'totalScore',
            component: TotalScore,
            meta: {requireAuth: false, title: '赛事总表'}
        },
        {
            path: '/gradeQuery',
            name: 'gradeQuery',
            component: GradeQuery,
            meta: {requireAuth: false, title: '积分明细'}
        },
        {
            path: '/fullcountdown',
            name: 'fullcountdown',
            component: FullCountdown,
            meta: {requireAuth: false, title: '倒计时'}
        },
        {
            path: '/fullArrange',
            name: 'fullArrange',
            component: FullArrange,
            meta: {requireAuth: false, title: '编排'}
        },
        {
            path: '/fullScoreQuery',
            name: 'fullScoreQuery',
            component: FullScoreQuery,
            meta: {requireAuth: false, title: '排名'}
        },
        {
            path: '/fullTotalTank',
            name: 'fullTotalTank',
            component: FullTotalTank,
            meta: {requireAuth: false, title: '总表'}
        },
        {
            path: '/fullScoreRefresh',
            name: 'fullScoreRefresh',
            component: FullScoreRefresh,
            meta: {requireAuth: false, title: '成绩公示'}
        },
        {
            path: '/fullGroupRankQuery',
            name: 'fullGroupRankQuery',
            component: FullGroupRankQuery,
            meta: {requireAuth: false, title: '团体排名'}
        },
        {
            path: '/newsDetail',
            name: 'newsDetail',
            component: NewsDetail,
            meta: { requireAuth: false, title: '新闻详情' }
        },
        {
            path: '/teamFullArrange',
            name: 'teamFullArrange',
            component: TeamFullArrange,
            meta: {requireAuth: false, title: '编排'}
        },
        {
            path: '/teamFullScoreRefresh',
            name: 'teamFullScoreRefresh',
            component: TeamFullScoreRefresh,
            meta: {requireAuth: false, title: '成绩公式'}
        },
        {
            path: '/teamFullGroupRankQuery',
            name: 'teamFullGroupRankQuery',
            component: TeamFullGroupRankQuery,
            meta: {requireAuth: false, title: '团队排名'}
        },
         {
            path: '/teamSign',
            name: 'teamSign',
            component: TeamSign,
            meta: {requireAuth: false, title: '签到计分'}
        },
    ]
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js